import { useShowHide, useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { modals } from '@modals';
import { useSupportContacts } from '@store';

interface NeedHelpHelperResources {
	title: string;
	subtitle: string;
	technicalHelp: string;
	coastLabel: string;
}

export interface NeedHelpHelperOutput {
	resources: NeedHelpHelperResources;
	numbers: string[];
	hide: () => void;
}

export const useNeedHelpHelper = (): NeedHelpHelperOutput => {
	const t = useTranslation();
	const numbers = useSupportContacts();

	const { hide } = useShowHide(modals.needHelp);

	const resources = {
		title: t('modals.needHelp.title'),
		subtitle: t('modals.needHelp.subtitle'),
		technicalHelp: t('modals.needHelp.technicalHelp'),
		coastLabel: t('modals.needHelp.coastLabel'),
	};

	return { resources, numbers, hide };
};
